import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { memo } from "../util/index.js";
import { erasHistoricApplyAccount } from "./util.js";
export function _stakerPoints(instanceId, api) {
  return memo(instanceId, function (accountId, eras, withActive) {
    var stakerId = api.registry.createType('AccountId', accountId).toString();
    return api.derive.staking._erasPoints(eras, withActive).pipe(map(function (points) {
      return points.map(function (_ref) {
        var era = _ref.era,
            eraPoints = _ref.eraPoints,
            validators = _ref.validators;
        return {
          era: era,
          eraPoints: eraPoints,
          points: validators[stakerId] || api.registry.createType('RewardPoint')
        };
      });
    }));
  });
}
export var stakerPoints = erasHistoricApplyAccount('_stakerPoints');